import { effect, inject, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '@shared/services/user.service';

@Pipe({
  name: 'hasAccess',
  standalone: true,
})
export class HasAccessPipe implements PipeTransform {
  private readonly _userService = inject(UserService);

  transform(value: string | string[]): boolean {
    // @ts-ignore
    return (
      this._userService
        .userSignal()
        ?.roles?.some(role => value?.includes(role.title) || value === 'OK') || false
    );
  }
}
